// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- 1. UPLOAD SECTION --- */
.border-dashed {
  border: 2px dashed #cbd5e1;
  transition: all 0.3s ease;
  cursor: pointer;
}

.border-dashed:hover {
  border-color: var(--primary-blue);
  background-color: #f1f5f9;
}
.upload-card {
  background-color: var(--card-bg) !important;
  border: 2px dashed var(--border-color);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.icon-drop-zone {
  color: var(--primary-purple); 
}

.drag-active {
  background-color: rgba(139, 92, 246, 0.05) !important; /* Soft purple hint */
  border-style: solid;
  border-color: var(--primary-purple) !important;
  transform: scale(1.02);
}

/* Analyzing State Text */
.text-primary {
  color: var(--primary-blue) !important;
}

[data-theme="dark"] .text-primary {
  color: #60a5fa !important;
}

.border-adaptive {
  border-color: var(--border-color) !important;
}

/* --- 2. BENTO & STAT CARDS --- */
.bento-card {
  background: white;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.bento-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
}

.icon-shape {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}

/* Stat Card Colors */
.border-bottom-custom-success {
  border-bottom: 4px solid #10b981;
}
.border-bottom-custom-info {
  border-bottom: 4px solid #3b82f6;
}
.border-bottom-custom-danger {
  border-bottom: 4px solid #ef4444;
}

.bg-success-soft {
  background-color: #ecfdf5;
}
.bg-info-soft {
  background-color: #eff6ff;
}
.bg-danger-soft {
  background-color: #fff1f2;
}

/* --- 3. CHART STYLING --- */
.chart-wrapper {
  position: relative;
  height: 250px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}

/* --- 4. MODERN ACCORDION (The Result Table) --- */
.modern-accordion {
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid #f1f5f9;
  overflow: visible !important;
  position: relative;
}

.priority-header {
  background-color: #f5f3ff;
  border-bottom: 1px solid #e2e8f0;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  position: relative;
  z-index: 10;
  overflow: visible !important;
}

.priority-row {
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.2s ease;
}

.priority-row:hover {
  background-color: #f8fafc;
}

/* Urgency Tags */
.urgency-tag {
  font-size: 10px;
  font-weight: 800;
  padding: 5px 12px;
  border-radius: 8px;
  display: inline-block;
  text-transform: uppercase;
}
.urgency-tag.danger {
  background: #fee2e2;
  color: #ef4444;
}
.urgency-tag.warning {
  background: #ffedd5;
  color: #f97316;
}
.urgency-tag.info {
  background: #fef9c3;
  color: #ca8a04;
}
.urgency-tag.success {
  background: #dbeafe;
  color: #3b82f6;
}

/* --- 5. INSIGHT DETAILS (EVIDENCE & ACTION PLAN) --- */
.detail-box {
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
}

.evidence-quote {
  font-size: 14px;
  color: #475569;
  font-style: italic;
  line-height: 1.6;
  display: flex;
  align-items: flex-start;
}

.evidence-quote i {
  color: var(--primary-purple);
  margin-top: -5px;
}

/* --- 6. FIX TOOLTIP POSITIONING --- */
.custom-tooltip {
  position: relative;
  cursor: help;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}

span.label-caps.custom-tooltip {
  display: inline-flex !important;
  margin-bottom: 0;
}

.custom-tooltip::before {
  content: attr(data-tooltip);
  position: absolute;
  /* Muncul tepat di atas teks */
  bottom: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  padding: 10px 14px;
  background-color: #1e293b;
  color: #ffffff;
  font-size: 11px;
  line-height: 1.4;
  border-radius: 10px;
  width: 200px;
  text-align: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease-out;
  z-index: 99999 !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  text-transform: none;
  font-weight: 400;
}

.custom-tooltip::after {
  content: "";
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  border: 6px solid transparent;
  border-top-color: #1e293b;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease-out;
  z-index: 99999 !important;
}

.custom-tooltip:hover::before,
.custom-tooltip:hover::after {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

/* Miscellaneous */
.chevron-icon {
  transition: transform 0.3s ease;
}

[aria-expanded="true"] .chevron-icon {
  transform: rotate(180deg);
}

.help-icon {
  font-size: 14px;
  color: #94a3b8;
}

/* --- ANALYZE ADAPTIVE CLASSES --- */

/* Reusable Adaptive Backgrounds */
.bg-soft-adaptive {
  background-color: #f8fafc; /* Light Mode */
  transition: all 0.3s ease;
}

.bg-card-adaptive {
  background-color: #ffffff; /* Light Mode */
  transition: all 0.3s ease;
}

.border-adaptive {
  border-color: #e2e8f0 !important;
}

/* --- DARK MODE OVERRIDES --- */
[data-theme="dark"] .bg-soft-adaptive {
  background-color: rgba(255, 255, 255, 0.03) !important;
}

[data-theme="dark"] .bg-card-adaptive {
  background-color: var(--card-bg) !important;
}

[data-theme="dark"] .border-adaptive {
  border-color: var(--border-color) !important;
}

/* --- ACCORDION DARK MODE --- */
[data-theme="dark"] .modern-accordion {
  background-color: var(--card-bg);
  border-color: var(--border-color);
}

[data-theme="dark"] .priority-header {
  background-color: rgba(139, 92, 246, 0.05); /* Soft Purple Hint */
  border-color: var(--border-color);
}

[data-theme="dark"] .priority-row {
  border-color: var(--border-color);
}

[data-theme="dark"] .priority-row:hover {
  background-color: rgba(255, 255, 255, 0.02);
}

/* Quote and Evidence */
[data-theme="dark"] .evidence-quote {
  color: var(--muted-text);
}

/* Chart Center Text */
[data-theme="dark"] .chart-overlay h2 {
  color: #fff;
}

/* --- RESPONSIVE OPTIMIZATION --- */
@media (max-width: 768px) {
  .priority-header {
    display: none !important;
  }

  .priority-row > div[role="button"] {
    flex-direction: column;
    align-items: flex-start !important;
    padding: 20px !important;
    gap: 12px;
  }

  .priority-row .flex-shrink-0:first-child {
    width: auto !important;
    margin-bottom: 4px;
  }

  .priority-row .flex-grow-1 {
    width: 100%;
    padding: 0 !important;
  }

  .priority-row .fw-600 {
    font-size: 15px;
    line-height: 1.5;
    -webkit-line-clamp: 3;
  }

  .priority-row .ms-auto {
    width: 100% !important;
    margin-left: 0 !important;
    margin-top: 8px;
    padding-top: 12px;
    border-top: 1px dashed #f1f5f9;
  }

  .priority-row .progress {
    height: 8px !important;
  }

  .priority-row .ms-3.flex-shrink-0 {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .detail-box {
    padding: 20px !important;
  }

  .evidence-quote {
    margin-bottom: 15px;
  }
}

@media (max-width: 480px) {
  .results-section {
    padding-top: 20px !important;
  }

  .bento-card h2 {
    font-size: 1.5rem;
  }

  .btn-primary.rounded-pill {
    width: 100%;
    margin-top: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/analyze.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD,EAAE,qBAAqB;EAC5E,mBAAmB;EACnB,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,SAAS;EACT,4CAA4C;EAC5C,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,0CAA0C;EAC1C,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,4CAA4C;EAC5C,6BAA6B;EAC7B,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qCAAqC;;AAErC,kCAAkC;AAClC;EACE,yBAAyB,EAAE,eAAe;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,gCAAgC;AAChC;EACE,sDAAsD;AACxD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,0CAA0C,EAAE,qBAAqB;EACjE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,wBAAwB;IACxB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["/* --- 1. UPLOAD SECTION --- */\n.border-dashed {\n  border: 2px dashed #cbd5e1;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.border-dashed:hover {\n  border-color: var(--primary-blue);\n  background-color: #f1f5f9;\n}\n.upload-card {\n  background-color: var(--card-bg) !important;\n  border: 2px dashed var(--border-color);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.icon-drop-zone {\n  color: var(--primary-purple); \n}\n\n.drag-active {\n  background-color: rgba(139, 92, 246, 0.05) !important; /* Soft purple hint */\n  border-style: solid;\n  border-color: var(--primary-purple) !important;\n  transform: scale(1.02);\n}\n\n/* Analyzing State Text */\n.text-primary {\n  color: var(--primary-blue) !important;\n}\n\n[data-theme=\"dark\"] .text-primary {\n  color: #60a5fa !important;\n}\n\n.border-adaptive {\n  border-color: var(--border-color) !important;\n}\n\n/* --- 2. BENTO & STAT CARDS --- */\n.bento-card {\n  background: white;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.bento-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);\n}\n\n.icon-shape {\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n}\n\n/* Stat Card Colors */\n.border-bottom-custom-success {\n  border-bottom: 4px solid #10b981;\n}\n.border-bottom-custom-info {\n  border-bottom: 4px solid #3b82f6;\n}\n.border-bottom-custom-danger {\n  border-bottom: 4px solid #ef4444;\n}\n\n.bg-success-soft {\n  background-color: #ecfdf5;\n}\n.bg-info-soft {\n  background-color: #eff6ff;\n}\n.bg-danger-soft {\n  background-color: #fff1f2;\n}\n\n/* --- 3. CHART STYLING --- */\n.chart-wrapper {\n  position: relative;\n  height: 250px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chart-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  pointer-events: none;\n}\n\n/* --- 4. MODERN ACCORDION (The Result Table) --- */\n.modern-accordion {\n  background: #ffffff;\n  border-radius: 24px;\n  border: 1px solid #f1f5f9;\n  overflow: visible !important;\n  position: relative;\n}\n\n.priority-header {\n  background-color: #f5f3ff;\n  border-bottom: 1px solid #e2e8f0;\n  border-top-left-radius: 24px;\n  border-top-right-radius: 24px;\n  position: relative;\n  z-index: 10;\n  overflow: visible !important;\n}\n\n.priority-row {\n  border-bottom: 1px solid #f1f5f9;\n  transition: background-color 0.2s ease;\n}\n\n.priority-row:hover {\n  background-color: #f8fafc;\n}\n\n/* Urgency Tags */\n.urgency-tag {\n  font-size: 10px;\n  font-weight: 800;\n  padding: 5px 12px;\n  border-radius: 8px;\n  display: inline-block;\n  text-transform: uppercase;\n}\n.urgency-tag.danger {\n  background: #fee2e2;\n  color: #ef4444;\n}\n.urgency-tag.warning {\n  background: #ffedd5;\n  color: #f97316;\n}\n.urgency-tag.info {\n  background: #fef9c3;\n  color: #ca8a04;\n}\n.urgency-tag.success {\n  background: #dbeafe;\n  color: #3b82f6;\n}\n\n/* --- 5. INSIGHT DETAILS (EVIDENCE & ACTION PLAN) --- */\n.detail-box {\n  border: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n}\n\n.evidence-quote {\n  font-size: 14px;\n  color: #475569;\n  font-style: italic;\n  line-height: 1.6;\n  display: flex;\n  align-items: flex-start;\n}\n\n.evidence-quote i {\n  color: var(--primary-purple);\n  margin-top: -5px;\n}\n\n/* --- 6. FIX TOOLTIP POSITIONING --- */\n.custom-tooltip {\n  position: relative;\n  cursor: help;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\nspan.label-caps.custom-tooltip {\n  display: inline-flex !important;\n  margin-bottom: 0;\n}\n\n.custom-tooltip::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  /* Muncul tepat di atas teks */\n  bottom: calc(100% + 12px);\n  left: 50%;\n  transform: translateX(-50%) translateY(10px);\n  padding: 10px 14px;\n  background-color: #1e293b;\n  color: #ffffff;\n  font-size: 11px;\n  line-height: 1.4;\n  border-radius: 10px;\n  width: 200px;\n  text-align: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease-out;\n  z-index: 99999 !important;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  pointer-events: none;\n  text-transform: none;\n  font-weight: 400;\n}\n\n.custom-tooltip::after {\n  content: \"\";\n  position: absolute;\n  bottom: calc(100% + 2px);\n  left: 50%;\n  transform: translateX(-50%) translateY(10px);\n  border: 6px solid transparent;\n  border-top-color: #1e293b;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease-out;\n  z-index: 99999 !important;\n}\n\n.custom-tooltip:hover::before,\n.custom-tooltip:hover::after {\n  opacity: 1;\n  visibility: visible;\n  transform: translateX(-50%) translateY(0);\n}\n\n/* Miscellaneous */\n.chevron-icon {\n  transition: transform 0.3s ease;\n}\n\n[aria-expanded=\"true\"] .chevron-icon {\n  transform: rotate(180deg);\n}\n\n.help-icon {\n  font-size: 14px;\n  color: #94a3b8;\n}\n\n/* --- ANALYZE ADAPTIVE CLASSES --- */\n\n/* Reusable Adaptive Backgrounds */\n.bg-soft-adaptive {\n  background-color: #f8fafc; /* Light Mode */\n  transition: all 0.3s ease;\n}\n\n.bg-card-adaptive {\n  background-color: #ffffff; /* Light Mode */\n  transition: all 0.3s ease;\n}\n\n.border-adaptive {\n  border-color: #e2e8f0 !important;\n}\n\n/* --- DARK MODE OVERRIDES --- */\n[data-theme=\"dark\"] .bg-soft-adaptive {\n  background-color: rgba(255, 255, 255, 0.03) !important;\n}\n\n[data-theme=\"dark\"] .bg-card-adaptive {\n  background-color: var(--card-bg) !important;\n}\n\n[data-theme=\"dark\"] .border-adaptive {\n  border-color: var(--border-color) !important;\n}\n\n/* --- ACCORDION DARK MODE --- */\n[data-theme=\"dark\"] .modern-accordion {\n  background-color: var(--card-bg);\n  border-color: var(--border-color);\n}\n\n[data-theme=\"dark\"] .priority-header {\n  background-color: rgba(139, 92, 246, 0.05); /* Soft Purple Hint */\n  border-color: var(--border-color);\n}\n\n[data-theme=\"dark\"] .priority-row {\n  border-color: var(--border-color);\n}\n\n[data-theme=\"dark\"] .priority-row:hover {\n  background-color: rgba(255, 255, 255, 0.02);\n}\n\n/* Quote and Evidence */\n[data-theme=\"dark\"] .evidence-quote {\n  color: var(--muted-text);\n}\n\n/* Chart Center Text */\n[data-theme=\"dark\"] .chart-overlay h2 {\n  color: #fff;\n}\n\n/* --- RESPONSIVE OPTIMIZATION --- */\n@media (max-width: 768px) {\n  .priority-header {\n    display: none !important;\n  }\n\n  .priority-row > div[role=\"button\"] {\n    flex-direction: column;\n    align-items: flex-start !important;\n    padding: 20px !important;\n    gap: 12px;\n  }\n\n  .priority-row .flex-shrink-0:first-child {\n    width: auto !important;\n    margin-bottom: 4px;\n  }\n\n  .priority-row .flex-grow-1 {\n    width: 100%;\n    padding: 0 !important;\n  }\n\n  .priority-row .fw-600 {\n    font-size: 15px;\n    line-height: 1.5;\n    -webkit-line-clamp: 3;\n  }\n\n  .priority-row .ms-auto {\n    width: 100% !important;\n    margin-left: 0 !important;\n    margin-top: 8px;\n    padding-top: 12px;\n    border-top: 1px dashed #f1f5f9;\n  }\n\n  .priority-row .progress {\n    height: 8px !important;\n  }\n\n  .priority-row .ms-3.flex-shrink-0 {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n  }\n\n  .detail-box {\n    padding: 20px !important;\n  }\n\n  .evidence-quote {\n    margin-bottom: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .results-section {\n    padding-top: 20px !important;\n  }\n\n  .bento-card h2 {\n    font-size: 1.5rem;\n  }\n\n  .btn-primary.rounded-pill {\n    width: 100%;\n    margin-top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
